const CARD = {
  R:   18,   // border-radius
  GAP: 16,   // gap between L-card notch and map card
};

let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

function buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`,
    ].join(' ');
}
function getCardConfig(W) {
    if (W < 640) {
        return {
            R: 10,
            GAP: 18,
            mapWidthRatio: 1.0,
            mapHeightRatio: 0.5,
            notch: false,   // ← plain rounded rect, no map cutout
        };
    }
    if (W < 900) {
        return { R: 18, GAP: 16, mapWidthRatio: 0.5, mapHeightRatio: 0.5, notch: true };
    }
    return {
        R: 18, 
        GAP: 16, 
        mapWidthRatio: 0.5, 
        mapHeightRatio: 0.5, 
        notch: true };
}
function buildNotchPath(W, H, MAP_W, MAP_H, R, GAP) {
    const NOTCH_X = (W - MAP_W) - GAP;   // left wall of the cut-out
    const NOTCH_Y = MAP_H + GAP;         // floor of the cut-out

    return [
        `M ${R} 0`,
        `L ${NOTCH_X - R} 0`,
        `A ${R} ${R} 0 0 1 ${NOTCH_X} ${R}`,
        `L ${NOTCH_X} ${NOTCH_Y - R}`,
        `A ${R} ${R} 0 0 0 ${NOTCH_X + R} ${NOTCH_Y}`,
        `L ${W - R} ${NOTCH_Y}`,
        `A ${R} ${R} 0 0 1 ${W} ${NOTCH_Y + R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`,
    ].join(' ');
}
function buildPath(W, H, CARD) {
    const cfg = getCardConfig(W);
    const MAP_W    = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H    = H * cfg.mapHeightRatio - cfg.GAP;
    const MAP_LEFT = W - MAP_W;
    const MAP_TOP  = 0;

    if (!cfg.notch) {
        // Mobile: simple rounded rect, no notch geometry needed
        return { d: buildRectPath(W, H, cfg.R), MAP_W, MAP_H, MAP_LEFT, MAP_TOP, cfg };
    }

    const d = buildNotchPath(W, H, MAP_W, MAP_H, cfg.R, cfg.GAP);

    return { d, MAP_W, MAP_H, MAP_LEFT, MAP_TOP, cfg };
}

    const mapCard = document.querySelector('.au-mapCard');
    const cardContent = document.getElementById('au-container');
    const cardRoot = document.querySelector('.au-card-root');
    const map = document.getElementById('au-mapCard');

    const c_photo_parent = document.querySelectorAll('.card-photo');
    const tm_details = document.querySelectorAll('.tm-details')
    const p_name = document.querySelectorAll('.name');
    const p_title = document.querySelectorAll('.title');

    let prevIsMobile = null;
    let lastW = 0, lastH = 0, lastCfg = null;

function reparentMapCard(isMobile) {
    if (isMobile === prevIsMobile) return;
    prevIsMobile = isMobile;

    if (isMobile) {
        mapCard.style.position = 'static';
        mapCard.style.background = "none";
        mapCard.style.boxShadow = "none";
        mapCard.style.width = '100%';
        console.log(c_photo_parent, p_name, p_title);

        // for (let i = 0; i < c_photo_parent.length -1; i++) {
        //     const heading = c_photo_parent[i].querySelector('.tm-heading');
        //     if (!heading) continue;
        //     heading.appendChild(p_name[i]);
        //     heading.appendChild(p_title[i]);
        // }
        cardContent.style.width = '100%';
        cardContent.insertBefore(mapCard, cardContent.children[1]);
        map.style.minHeight= '0';
        
    } else {
        cardRoot.appendChild(mapCard);
        mapCard.style.position = 'absolute';
        mapCard.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        mapCard.style.boxShadow = "8px 8px 10px rgba(0, 0, 0, 0.4), -10px -15px 20px rgba(255, 255, 255, 0.2), inset 0 -3px 4px -1px rgba(0, 0, 0, 0.4), inset 0 3px 4px -1px rgba(255,255,255,0.4), inset 0 0 5px 1px rgba(255,255,255,0.8),  inset 0 20px 30px 0 rgba(255,255,255,0.2)";
        map.style.minHeight = `${MAP_H}px`;

        for (let i = 0; i < c_photo_parent.length; i++) {
            const heading = c_photo_parent[i].querySelector('.tm-heading');
            if (!heading) continue;
            heading.appendChild(p_name[i]);
            heading.appendChild(p_title[i]);
        }

        const mapTXT_OUR_STORY = document.getElementById("au-txt-ourstory");
        if (mapTXT_OUR_STORY) {
            mapTXT_OUR_STORY.style.minHeight = `${MAP_H - 36}px`;
        }
    }
}

    function applyGeometry(W, H) {
        const { d, MAP_W, MAP_H, MAP_LEFT, MAP_TOP, cfg } = buildPath(W, H, CARD);

        lastW = W; lastH = H; lastCfg = cfg;

        // L-card clip
        const auCard = document.getElementById('au-l-card');
        if (auCard) auCard.style.clipPath = `path("${d}")`;

        // Single SVG path — convex-bubble filter only
        const shadowPath = document.getElementById('au-insetLightPath');
        if (shadowPath) shadowPath.setAttribute('d', d);

        // SVG canvas sizing
        const svg = document.getElementById('au-insetSvg');
        if (svg) {
            svg.setAttribute('width',  W);
            svg.setAttribute('height', H);
        }

        // Map card position + size — MAP_H is only a floor; content may grow it further
        const map = document.getElementById('au-mapCard');
        if (map) {
            map.style.left      = `${MAP_LEFT}px`;
            map.style.top       = `${MAP_TOP}px`;
            map.style.width     = `${MAP_W}px`;
            // map.style.minHeight = `${MAP_H}px`;
        }
    }

    // Keeps the notch cut-out in sync with au-mapCard's real (content-driven)
    // height, independent of whether cardRoot itself resized.
    function applyNotchFromMapHeight(mapH) {
        if (!lastCfg || !lastCfg.notch) return; // mobile: plain rect, no notch to sync

        const MAP_W = lastW * lastCfg.mapWidthRatio - lastCfg.GAP;
        const d = buildNotchPath(lastW, lastH, MAP_W, mapH, lastCfg.R, lastCfg.GAP);

        const auCard = document.getElementById('au-l-card');
        if (auCard) auCard.style.clipPath = `path("${d}")`;

        const shadowPath = document.getElementById('au-insetLightPath');
        if (shadowPath) shadowPath.setAttribute('d', d);
    }

const ro = new ResizeObserver(entries => {
    const { width, height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    reparentMapCard(isMobile);
    applyGeometry(width, height); // always runs now
});

ro.observe(cardRoot);

// Separate observer: reacts only to au-mapCard's own box (content growth,
// font swaps, etc.) — offsetHeight avoids contentRect's content-box-only
// measurement, which would exclude au-mapCard's padding.
const mapRo = new ResizeObserver(() => {
    if (mapCard) applyNotchFromMapHeight(mapCard.offsetHeight);
});

if (mapCard) mapRo.observe(mapCard);